import { Archive } from '@phosphor-icons/react';
import React, { useState } from 'react';
import { FluxObject } from '../AgentsSidebar/context';
import { useSidebarItemDraggable } from '../AgentsSidebar/useSidebarItemDraggable';
import { DraggableItemShell } from '../dnd/DraggableItemShell';
import type { ReservedFolderType } from '../dnd/types';
import { ActionMenu } from './ActionMenu';
import { Item } from './Item';
import { useDataSidebarContext } from './context';

interface ObjectItemProps {
  object: FluxObject;
  spaceId?: string | null;
  ancestorReservedType?: ReservedFolderType | null;
  onEdit?: (object: FluxObject) => void;
  onDelete?: (object: FluxObject) => void;
  isNested?: boolean;
}

const ObjectItemComponent: React.FC<ObjectItemProps> = ({
  object,
  spaceId,
  ancestorReservedType = null,
  onEdit,
  onDelete,
  isNested = true,
}) => {
  const { activeObjectId, onObjectClick } = useDataSidebarContext();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const draggable = useSidebarItemDraggable({
    itemId: object.id,
    kind: 'object',
    parentId: object.folderId ?? null,
    spaceId: object.spaceId ?? spaceId ?? null,
    label: object.name,
    ancestorReservedType,
  });

  const handleMenuClick = (anchor: HTMLElement) => {
    setAnchorEl(anchor);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <DraggableItemShell
      ref={draggable.setNodeRef}
      isDragging={draggable.isDragging}
      dropAbove={draggable.showDropAbove}
      dropBelow={draggable.showDropBelow}
    >
      <Item
        icon={<Archive size={16} />}
        label={object.name}
        isActive={activeObjectId === object.id}
        isMenuOpen={Boolean(anchorEl)}
        isNested={isNested}
        onClick={() => onEdit && onEdit(object)}
        onMenuClick={handleMenuClick}
      />
      <ActionMenu
        anchorEl={anchorEl}
        onClose={handleClose}
        onEdit={onEdit ? () => onEdit(object) : undefined}
        onDelete={onDelete ? () => onDelete(object) : undefined}
        showEdit={true}
      />
    </DraggableItemShell>
  );
};

export const ObjectItem = React.memo(ObjectItemComponent);
